import { SET_RX_FORM_VALUES } from './types';

const setRxFormValues = values => {
  return {
    type: SET_RX_FORM_VALUES,
    payload: values,
  };
};

export default setRxFormValues;



// WEBPACK FOOTER //
// ./src/actions/userInformation/setRxFormValues.js